<template>
    <v-row no-gutters>
        <v-col cols="12">
            <!-- <v-sheet height="64" class="mb-2" style="border-radius: 16px"> -->
            <v-toolbar flat rounded="xl" class="mb-2">
                <v-btn-primary rounded @click="setToday" class="mr-4">
                    {{ viewMode === "day" ? " Retour " : "Aujourd'hui" }}
                </v-btn-primary>
                <v-btn-prev @click="prev" size="small"> </v-btn-prev>
                <v-btn-next @click="next" size="small"> </v-btn-next>
                <v-toolbar-title v-if="calendar">
                    {{ displayTodayMonth(today) }}
                </v-toolbar-title>
                <v-spacer />

                <v-btn-toggle
                    v-model="windowStep"
                    rounded="xl"
                    @click="refreshTasks"
                    class="mb-1"
                    mandatory
                >
                    <v-btn-icon value="taskscalendarview" icon="$oss-calendar"> </v-btn-icon>
                    <v-btn-icon value="taskslistview" icon="$fa-list"> </v-btn-icon>
                </v-btn-toggle>
                <!-- <v-menu bottom right>
            <template v-slot:activator="{ on, props }">
              <v-btn rouded elevation="0"  v-bind="props" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right> $fa-chevron-down </v-icon>
              </v-btn>
            </template>
<v-list>
    <v-list-item @click="type = 'week'">
        <v-list-item-title>Semaine</v-list-item-title>
    </v-list-item>
    <v-list-item @click="type = 'month'">
        <v-list-item-title>Mois</v-list-item-title>
    </v-list-item>
    <v-list-item @click="type = '4day'">
        <v-list-item-title>4 jours</v-list-item-title>
    </v-list-item>
    <v-list-item @click="type = 'day'">
        <v-list-item-title>Jour</v-list-item-title>
    </v-list-item>
</v-list>
</v-menu> -->
            </v-toolbar>
            <!-- </v-sheet> -->
            <v-window v-model="windowStep">
                <v-window-item value="taskscalendarview">
                    <v-sheet style="border-radius: 16px" height="800">
                        <v-row no-gutters>
                            <v-col cols="12" class="mb-2">
                                <v-calendar
                                    ref="calendar"
                                    v-model="focus"
                                    :events="tasksCalendar"
                                    :event-color="getEventColor"
                                    :view-mode="viewMode"
                                    :key="refreshKey"
                                    interval-count="0"
                                    :interval-height="0"
                                    hide-header
                                    @click:event="editTaskInCalendarView"
                                    @click:more="viewDay"
                                    @click:date="clickCalendarNewEvent"
                                >
                                </v-calendar>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </v-window-item>
                <v-window-item value="taskslistview">
                    <v-row v-if="!tasksDatabase && !tasksDatabase.length" no-gutters>
                        <v-col cols="12">
                            <v-card
                                elevation="0"
                                style="background-color: #ffffff; border-radius: 25px"
                            >
                                <v-card-title class="pa-4 d-flex justify-center">
                                    Aucune t&#xe2;ches ce mois-ci
                                </v-card-title>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row v-else no-gutters>
                        <v-col cols="12" class="d-flex justify-center">
                            <!-- <v-list rounded style="overflow-y: auto; height:50vh border-radius: 25px; background: transparent;">
                  <v-list-item
                      v-for="(task, index) in taskList"
                      :key="index"
                      :value="task.id"
                      style="width:50vw"
                      class="oss-list-item mb-2"
                  >
                      <template v-slot:append
                        class="d-flex align-center justify-center"
                      >
                        <v-tooltip left
                          v-if="statusIcon(task.status)"
                        >
                          <template v-slot:activator="{ on }">
                              <v-icon
                                  v-on="on"
                                  :color="statusColor(task)"
                                  @click.stop="changeTaskStatus(task)">
                                  {{statusIcon(task.status)}}
                              </v-icon>
                          </template>
                          <span>{{ statusText(task) }}</span>
                        </v-tooltip>
                      </template>
                      <template class="py-0">
                          <v-list-item-title
                            class="d-flex mt-1"
                          >
                                <p
                                  class="mt-1 mr-3"
                                >
                                  {{ task.title }}
                                </p>
                                <v-chip
                                    outlined
                                    :color="getEventColor(task)"
                                     size="small"
                                >
                                    <span
                                        :color="getEventColor(task)"
                                    >
                                        {{setSpanType(task.type)}}
                                    </span>
                                </v-chip>
                          </v-list-item-title>
                          <v-list-item-subtitle
                          >
                            <v-icon  size="small">$oss-calendar</v-icon>
                              {{formatDateTable(task.dueDate)}}
                          </v-list-item-subtitle>
                        <v-list-item-title
                          class="my-2"
                        >
                        </v-list-item-title>
                        <v-list-item-subtitle
                          class="my-1 mb-2"
                        >
                          <v-icon class="ml-2"  size="small">$oss-calendar</v-icon>
                            <span class="ml-2">{{formatDateTable(task.dueDate)}}</span>
                            <span class="ml-2" style="color:red">{{getDateFromNow(task,today)}}</span>
                          <v-icon class="ml-2"  size="small">$oss-outlined-user</v-icon>
                          {{ (task.members && task.members.length) ? formatSelectedUsers(task.members) : "Aucun membre pour cette tâche"}}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle
                          class="my-1"
                        >
                            Description: {{task.description}}
                        </v-list-item-subtitle>
                      </template>
                      <template v-slot:append
                        class="d-flex align-center justify-center"
                      >
                        <v-menu absolute offset-y>
                          <template v-slot:activator="{ on, props }">
                              <v-btn
                                v-bind="props"
                                v-on="on"
                                icon
                                color="primary"
                              >
                                  <v-icon>$dots_vertical</v-icon>
                              </v-btn>
                          </template>
                          <v-list>
                              <v-list-item
                                  @click.stop="editTaskInListView(task)"
                              >
                                  <v-list-item-title>Modifier</v-list-item-title>
                                  <template v-slot:append>
                                      <v-icon  size="small">$oss-edit</v-icon>
                                  </template>
                              </v-list-item>
                              <v-list-item
                                  @click.stop="deleteTask(task)"
                              >
                                  <v-list-item-title>Supprimer</v-list-item-title>
                                  <template v-slot:append>
                                      <v-icon  size="small">$oss-trash</v-icon>
                                  </template>
                              </v-list-item>
                          </v-list>
                      </v-menu>
                      </template>
                  </v-list-item>
              </v-list> -->

                            <oss-data-table
                                :headers="tasksTableHeaders"
                                :items="taskList"
                                :itemLength="taskCount"
                                :show-select="false"
                                :x-dense="true"
                                :striped="false"
                                :table-hover="true"
                                :fixed-footer="true"
                                :fixed-header="true"
                                :row-styles="rowStyles"
                                checkbox-color="primary"
                                @clickRow="editTaskInListView($event)"
                            >
                                <template v-slot:item.id="{ item }">
                                    <v-menu absolute offset-y>
                                        <template v-slot:activator="{ props }">
                                            <v-btn-icon
                                                icon="$dots_vertical"
                                                v-bind="props"
                                                class="mx-1"
                                                color="primary"
                                            />
                                        </template>
                                        <v-list>
                                            <v-list-item @click.stop="editTaskInListView(item)">
                                                <v-list-item-title>{{
                                                    item.auto === true ? "Visualiser" : "Modifier"
                                                }}</v-list-item-title>
                                                <template v-slot:append>
                                                    <v-icon v-if="item.auto === true" size="small"
                                                        >$oss-eye</v-icon
                                                    >
                                                    <v-icon v-else size="small">$oss-edit</v-icon>
                                                </template>
                                            </v-list-item>
                                            <v-list-item @click.stop="deleteTask(item)">
                                                <v-list-item-title>Supprimer</v-list-item-title>
                                                <template v-slot:append>
                                                    <v-btn-trash size="small"></v-btn-trash>
                                                </template>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                                <template v-slot:item.owner="{ item }">
                                    {{ formatUserTaskFrom(item.owner) }}
                                </template>
                                <template v-slot:item.members="{ item }">
                                    {{ formatSelectedUsers(item.members) }}
                                </template>
                                <template v-slot:item.dueDate="{ item }">
                                    <span>{{ formatDateTable(item.dueDate) }}</span>
                                    <span style="color: red">
                                        {{
                                            getDateFromNow(item) !== "" ? getDateFromNow(item) : ""
                                        }}</span
                                    >
                                </template>
                                <template v-slot:item.start="{ item }">
                                    {{ formatDateTable(item.start) }}
                                </template>
                                <template v-slot:item.client="{ item }">
                                    {{ formatCompany(item.client) }}
                                </template>
                                <template v-slot:item.type="{ item }">
                                    {{ formatType(item.type) }}
                                </template>
                                <!-- <template v-slot:item.end="{ item }">
                    {{getDateFromNow(item)}}
                </template> -->
                                <template v-slot:item.status="{ item }">
                                    <v-tooltip v-if="statusIcon(item.status)" location="start">
                                        <template v-slot:activator="{ props }">
                                            <v-icon
                                                :color="statusColor(item)"
                                                @click.stop="changeTaskStatus(item)"
                                                size="small"
                                                v-bind="props"
                                            >
                                                {{ statusIcon(item.status) }}
                                            </v-icon>
                                        </template>
                                        <span>{{ statusText(item) }}</span>
                                    </v-tooltip>
                                </template>
                            </oss-data-table>
                        </v-col>
                    </v-row>
                </v-window-item>
            </v-window>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import TASKS from "../../graphql/tasks/Tasks.gql";
import OssDataTable from "../ossComponents/ossDataTable2.vue";
import UPSERT_TASK from "../../graphql/tasks/UpsertTasks.gql";
import DELETE_TASK from "../../graphql/tasks/DeleteTasks.gql";
import { getDBFormattedEndMonthDate, getDBFormattedStartMonthDate } from "@/services/dateServices";
import { Component, Vue, Ref, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { VCalendar } from "vuetify/labs/VCalendar";

@Component({
    components: {
        OssDataTable,
    },
    emits: ["task-date", "edit-event"],
})
export class TasksCalendar extends Vue {
    @Prop({ default: "" }) accountingFirmId: string;
    @Prop({ default: "" }) clientId: string;
    @Prop({ default: null }) selectedUser: any;
    @Prop({ default: null }) selectedMember: any;
    @Prop({ default: null }) tasksFromParentComponent: any;
    @Prop({ default: "" }) typeStatusFilter: string;

    @Ref("calendar") calendar: VCalendar;

    focus = [];
    viewMode: "month" | "day" | "week" = "month";
    refreshKey = 0;

    today = moment();

    windowStep = "taskscalendarview";

    taskCalendar = {
        id: "",
        start: "",
        end: "",
        name: "",
        description: "",
        owner: {
            firstname: "",
            lastname: "",
        },
        type: "",
        status: "",
        members: [],
        company: {
            id: "",
            name: "",
        },
        client: {
            id: "",
            name: "",
        },
    };

    taskSearch = "";

    taskDeleteIds = [];

    tasksCalendar = [];

    expandedTaskIds = [];

    colors = ["blue", "indigo", "orange", "cyan", "green", "deep-purple", "grey en-1"];

    beforeMount() {
        this.showTaskInCalendar();
    }

    get startPeriod() {
        return getDBFormattedStartMonthDate(this.today);
    }

    get endPeriod() {
        return getDBFormattedEndMonthDate(this.today);
    }

    @Apollo({
        query: TASKS,
        variables() {
            // debugger
            return {
                accountingFirmId: this.accountingFirmId,
                client: this.clientId ? { id: this.clientId } : undefined,
                owner: this.selectedUser?.id ? { id: this.selectedUser.id } : undefined,
                member: this.selectedMember?.id ? { id: this.selectedMember.id } : undefined,
                status:
                    this.typeStatusFilter && this.typeStatusFilter !== "ALL"
                        ? this.typeStatusFilter
                        : undefined,
                start: this.startPeriod,
                end: this.endPeriod,
            };
        },
        skip() {
            return !this.accountingFirmId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingTasks = loading;
            if (!loading) {
                if (data?.tasks?.length) {
                    // debugger
                    this.tasksDatabase = data.tasks;
                } else {
                    this.tasksDatabase = [];
                }
            }
        },
    })
    tasksDatabase: any = [];

    get tasksTableHeaders() {
        const header: Array<any> = [
            {
                text: "Date d'échéance",
                value: "dueDate",
                align: "left",
                sortable: true,
                filterable: { type: "includes", options: { input: "date" } },
            },
            // { text: "Créé par", value: "owner", align: "left", sortable: true, filterable: { type: 'equals', options: { toText: (owner) => { return this.formatUserTaskFrom(owner)}}} },
            {
                text: "Type",
                value: "type",
                align: "left",
                sortable: true,
                filterable: {
                    type: "equals",
                    options: {
                        toText: (type) => {
                            return this.formatType(type);
                        },
                    },
                },
            },
            { text: "Titre", value: "title", align: "left", sortable: false },
            { text: "Description", value: "description", align: "left", sortable: false },
            {
                text: "Attribué à",
                value: "members",
                align: "left",
                sortable: true,
                filterable: {
                    type: "equals",
                    options: {
                        toText: (members) => {
                            return this.formatSelectedUsers(members);
                        },
                    },
                },
            }, // Pas correct pour members
            // {text: "Début", value: "start", align: "center", sortable: true,},
            { text: "Statut", value: "status", align: "center", sortable: false },
            // { text: "", value: "", sortable: false },
        ];

        if (this.$router.currentRoute.value.name !== "tasks") {
            header.push({
                text: "Tiers",
                value: "client",
                align: "left",
                sortable: true,
                filterable: {
                    type: "equals",
                    options: {
                        toText: (client) => {
                            return this.formatCompany(client);
                        },
                    },
                },
            });
        }

        header.push({ text: "", value: "id", sortable: false, verticalStickyEnd: true });

        return header;
    }

    get taskCount() {
        if (this.tasksDatabase) {
            return this.tasksDatabase.length;
        }
        return null;
    }

    get rowStyles() {
        let styles = "border-top: solid 8px #F4F4F4";
        let rowStylesTable = [];
        let previousDate = "";

        // debugger

        for (const task of this.tasksDatabase) {
            if (task.dueDate !== previousDate) {
                rowStylesTable.push(styles);
            } else {
                rowStylesTable.push(undefined);
            }

            previousDate = task.dueDate;
        }

        return rowStylesTable;
    }

    async deleteTask(taskToDelete) {
        if (taskToDelete) {
            // debugger

            console.log("task", taskToDelete.id);
            this.taskDeleteIds.push(taskToDelete.id);

            if (taskToDelete.tasks) {
                for (const taskOfRecurringTask of taskToDelete.tasks) {
                    this.taskDeleteIds.push(taskOfRecurringTask.id);
                }
            }
            if (this.taskDeleteIds.length) {
                const result = await this.$apollo.mutate({
                    mutation: DELETE_TASK,
                    variables: {
                        ids: this.taskDeleteIds,
                    },
                });
                this.taskDeleteIds = [];

                if (result) {
                    this.tasksDatabase = this.tasksDatabase.filter(
                        (task) => task.id !== taskToDelete.id,
                    );
                }
            }
        }
    }

    async changeTaskStatus(task) {
        // On fournit une tâche spécifique
        if (task) {
            if (task.status === "DONE") {
                task.status = "TO_BE_DONE";
            } else {
                task.status = "DONE";
            }
            if (task?.id) {
                await this.$apollo.mutate({
                    mutation: UPSERT_TASK,
                    variables: {
                        id: task.id,
                        status: task.status,
                        recurringTaskId: task.recurringTaskId ? task.recurringTaskId : undefined,
                    },
                });
            }
        }
    }

    get taskList() {
        const taskList = [];
        if (this.tasksDatabase?.length) {
            for (const taskDatabase of this.tasksDatabase) {
                if (
                    !(
                        taskDatabase.periodicity !== null &&
                        taskDatabase?.tasks &&
                        taskDatabase?.tasks?.length
                    )
                ) {
                    taskList.push(taskDatabase);
                }
            }
        }
        return taskList;
    }

    formatCompany(client) {
        if (client) {
            // debugger
            return client.name;
        }
        return "";
    }

    formatStatus(status) {
        if (status) {
            switch (status) {
                case "TO_BE_DONE":
                    return "En cours";
                case "DONE":
                    return "Terminée";
            }
        }
    }

    formatPeriodicity(periodicity) {
        if (periodicity) {
            switch (periodicity) {
                case null:
                    return "Aucune";
                case "MONTHLY":
                    return "Mensuel";
                case "QUARTERLY":
                    return "Trimestriel";
                case "ANNUAL":
                    return "Annuel";
            }
        }
    }

    formatType(type) {
        if (type) {
            switch (type) {
                case "MISCELLANEOUS":
                    return "Divers";
                case "VAT":
                    return "TVA";
            }
        }
    }

    formatUserTaskFrom(owner) {
        if (owner) {
            return owner.firstname + " " + owner.lastname;
        }
        return "";
    }

    formatSelectedUsers(members) {
        if (members) {
            // debugger
            let nbUsers = 0;
            nbUsers = members.length - 1;
            for (const selectedUser of members) {
                if (members.length < 2) {
                    return selectedUser.firstname + " " + selectedUser.lastname;
                } else {
                    return (
                        members[0].firstname +
                        " " +
                        members[0].lastname +
                        " +" +
                        nbUsers +
                        " personne(s)"
                    );
                }
            }
        }
        return "";
    }

    formatDateTable(dueDate) {
        if (!dueDate) return "";
        return moment(dueDate).format("DD/MM/YYYY");
    }

    getDateFromNow(task) {
        debugger;

        const todayDate = new Date();

        if (task) {
            if (task.status === "TO_BE_DONE") {
                const taskDueDate = moment(task.dueDate).format("YYYY-MM-DD");
                const dueDateInDate = new Date(taskDueDate);

                if (dueDateInDate < todayDate) {
                    return moment(dueDateInDate).fromNow(true) + " de retard";
                } else {
                    return "";
                }
            }
        }

        return "";

        // return dateFromNow +" de retard"
    }

    formatDateHeader(date) {
        const fDate = date;
        return fDate;
    }

    statusColor(task) {
        const todayDate = new Date();

        //debugger
        if (task) {
            if (task.status === "TO_BE_DONE") {
                const endDateString = moment(task.dueDate).format("YYYY-MM-DD");
                const dueDate = new Date(endDateString);

                if (dueDate < todayDate) {
                    return "red";
                } else {
                    return "magic";
                }
            }
            if (task.status === "DONE") {
                return "secondary";
            }
        }
    }

    statusText(task) {
        const todayDate = new Date();

        //debugger
        if (task) {
            switch (task.status) {
                case "TO_BE_DONE": {
                    const endDateString = moment(task.dueDate).format("YYYY-MM-DD");
                    const dueDate = new Date(endDateString);

                    if (dueDate < todayDate) {
                        return "Date d'échéance dépassée";
                    } else {
                        return "En cours";
                    }
                }
                case "DONE": {
                    return "Terminée";
                }
            }
        }
    }

    setSpanType(type) {
        if (type) {
            if (type === "MISCELLANEOUS") {
                return "Divers";
            } else {
                return "TVA";
            }
        }
    }

    statusIcon(status) {
        //debugger
        if (status) {
            if (status === "TO_BE_DONE") {
                return "$oss-circle-uncheck";
            }
            if (status === "DONE") {
                return "$fa-check-circle";
            }
        }
    }

    @Watch("today")
    displayTodayMonth(today) {
        let displayDate = moment(today).format("MMMM Y");

        if (today) {
            return displayDate;
        }

        return "";
    }

    viewDay({ date }) {
        // debugger
        this.focus.push(date);
        this.viewMode = "day";
        console.log(date);
    }

    clickCalendarNewEvent({ date }) {
        if (date) {
            // debugger
            this.$emit("task-date", date);
            this.$apollo.queries.tasksDatabase.refetch();
        }
    }

    getEventColor(event) {
        // debugger
        switch (event.type) {
            case "MISCELLANEOUS":
                return (event.color = this.colors[2]);
            case "VAT":
                return (event.color = this.colors[3]);
            case "IS":
                return (event.color = this.colors[4]);
        }
    }

    setToday() {
        if (this.viewMode === "day") {
            this.viewMode = "month";
        }

        this.focus = [];
        this.today = moment();
    }

    prev() {
        debugger;
        //@ts-ignore
        this.calendar.onClickPrev();
        //@ts-ignore
        this.today = moment(this.today).add(-1, "month");
    }

    next() {
        debugger;
        //@ts-ignore
        this.calendar.onClickNext();
        debugger;
        //@ts-ignore
        this.today = moment(this.today).add(1, "month");
    }

    editTaskInCalendarView({ event }) {
        if (event) {
            // debugger
            const taskToEditDB = this.tasksDatabase.findIndex((task) => task.id === event.id);
            this.$emit("edit-event", this.tasksDatabase[taskToEditDB]);
        }
    }

    editTaskInListView(event) {
        if (event) {
            // debugger
            const taskToEditDB = this.tasksDatabase.findIndex((task) => task.id === event.id);
            this.$emit("edit-event", this.tasksDatabase[taskToEditDB]);
        }
    }

    @Watch("tasksDatabase", { deep: true })
    showTaskInCalendar() {
        // debugger
        if (this.tasksDatabase) {
            this.tasksCalendar = [];

            for (const taskDatabase of this.tasksDatabase) {
                const taskDatabaseCopy = JSON.parse(JSON.stringify(taskDatabase));
                // debugger
                const taskDateFormat = moment(taskDatabaseCopy.dueDate).format("YYYY-MM-DD");

                this.taskCalendar = {
                    id: taskDatabaseCopy.id,
                    start: taskDateFormat,
                    end: taskDateFormat,
                    name: taskDatabaseCopy.title,
                    description: taskDatabaseCopy.description,
                    owner: taskDatabaseCopy.owner,
                    type: taskDatabaseCopy.type,
                    status: taskDatabaseCopy.status,
                    members: taskDatabaseCopy.members,
                    company: taskDatabaseCopy.company,
                    client: taskDatabaseCopy.client,
                };

                this.tasksCalendar.push(this.taskCalendar);
            }
            this.refreshKey++;
        }
    }

    @Watch("tasksFromParentComponent", { deep: true })
    refreshTasks() {
        //@ts-ignore
        // this.calendar.checkChange()
        this.$apollo.queries.tasksDatabase.refetch();
    }
}

export default toNative(TasksCalendar);
</script>
